import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import { useState, useEffect } from "react";
import { makePostRequest, makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import moment from "moment";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import SearchIcon from "@mui/icons-material/Search";
import Zoom from "react-medium-image-zoom";

import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import ReplayCircleFilledIcon from "@mui/icons-material/ReplayCircleFilled";
import avtarPic from "../../../assets/Images/avtarPic.png";

function AddEvent() {
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = React.useState(false);
  const [eventTitle, seteventTitle] = useState("");
  const [description, setDescription] = useState("");
  const [evenue, setevenue] = useState("");
  // const [groupid, setgroupid] = React.useState("");

  // const [checkval, setCheckval] = useState(false);
  const [rsvp, setrsvp] = useState(false);
  // const [usertype, setusertype] = useState('');
  // const [value, setValue] = useState("All");

  const [eventStartDate, setEventStartDate] = React.useState(dayjs(new Date()));
  const [eventEndDate, setEventEndDate] = React.useState(dayjs(new Date()));

  const [errmsgradiobtn, seterrmsgradiobtn] = React.useState(false);
  const [showerr, setshowerr] = React.useState(false);
  const [membersIds, setMembersIds] = React.useState([]);
  const [radiovalue, setradioValue] = React.useState("");
  const [isSelectGroup, setIsSelectGroup] = React.useState(false);
  const [groupsList, setGroupsList] = React.useState([]);

  const [group_name, setGroupName] = React.useState("");
  const [group_description, setGroupDesc] = React.useState("");
  const [open3, setOpen3] = React.useState(false);
  const [, setressearch] = React.useState("");
  const [scroll] = React.useState("paper");
  const [selectedGroup, setSelectedGroup] = React.useState("");
  const [, setScroll3] = React.useState("paper");
  // const [isEditFlag, setIsEditFlag] = React.useState();
  const [eventId, setEventId] = React.useState();
  const [, setflgforedit] = React.useState("set");
  const [fcmarr, setfcmarr] = React.useState([]);

  const [residentlist, setresidentlist] = React.useState([]);
  const [, setActiveIndex] = React.useState();
  
  const { id } = useParams();

  let memberArr = [];

  async function addEvent() {

    if (id > 0) {
      // const sDate = new Date(eventStartDate);
      // const eDate = new Date(eventEndDate);
      // let newsdate = moment(sDate).format("YYYY-MM-DD HH:mm:ss")
      // let newedate = moment(eDate).format("YYYY-MM-DD HH:mm:ss")

      let rsvpval;
      if (rsvp) {
        rsvpval = 1;
      } else {
        rsvpval = 0;
      }
      var inputdata = "";
      if (radiovalue === "") {
        seterrmsgradiobtn(true);
        return false;
      }
      else {
        const sDate = new Date(eventStartDate);
        const eDate = new Date(eventEndDate);
        let newsdate = moment(sDate).format("YYYY-MM-DD HH:mm:ss")
        let newedate = moment(eDate).format("YYYY-MM-DD HH:mm:ss")

        if (eDate > sDate) {
          setShowLoader(true);
          inputdata = {
            event_id: eventId,
            event_title: eventTitle,
            event_description: description,
            event_venue: evenue,
            start_date_time: newsdate,
            end_date_time: newedate,
            sender_id: parseInt(localStorage.getItem("userId")),
            ...(radiovalue === "Groups" ? { group_id: selectedGroup } : {}),
            allow_rsvp: rsvpval,
            event_visible_flag: radiovalue,
            // member_id_list: membersIds,
          };

          makePostRequest("events/update", inputdata)
            .then((response) => {
              if (response.data.status === "1") {
                swal("Success", "Events updated successfully", "success", {
                  timer: 1000,
                  buttons: false,
                });
                setradioValue("");
                setShowLoader(false);
                navigate("/ViewEvents");
              }
            })
            .catch((err) => {
              setShowLoader(false);
              swal("There was an error!", "more error details", "warning");
            });
        } else {
          swal("Invalid Time!", 'Event end time should be greater than start time', "warning");
        }
      }
      // else {
      //   seterrmsgradiobtn(false);
      //   if (
      //     radiovalue === "All" ||
      //     radiovalue === "Committee Members" ||
      //     radiovalue === "Owners"
      //   ) {
      //     let optn = '';
      //     if (radiovalue === "All") {
      //       optn = "all"
      //     } else if (radiovalue === "Owners") {
      //       optn = "allOwners"
      //     } else if (radiovalue === "Committee Members") {
      //       optn = "committeeMembers"
      //     } else if (radiovalue === "Groups") {
      //       optn = "Groups"
      //     } else {
      //       optn = radiovalue
      //     }
      //     let bodyFormData = "";
      //     setShowLoader(true);
      //     await makeGetRequest("post/getallMembersid/" + optn, bodyFormData)
      //       .then((response) => {
      //         if (response.status === 201) {
      //           for (var i = 0; i < response.data.data.length; i++) {
      //             memberArr.push(response.data.data[i].resident_id);
      //           }
      //           setMembersIds(memberArr);
      //           inputdata = {
      //             event_id: eventId,
      //             event_title: eventTitle,
      //             event_description: description,
      //             event_venue: evenue,
      //             start_date_time: eventStartDate,
      //             end_date_time: eventEndDate,
      //             sender_id: parseInt(localStorage.getItem("userId")),
      //             ...(radiovalue === "Groups" ? { group_id: selectedGroup } : {}),
      //             allow_rsvp: rsvpval,
      //             event_visible_flag: radiovalue,
      //             member_id_list: memberArr,
      //           };

      //           makePostRequest("events/update", inputdata)
      //             .then((response) => {
      //               if (response.data.status === "1") {
      //                 swal("Success", "Events updated successfully", "success", {
      //                   timer: 1000,
      //                   buttons: false,
      //                 });

      //                 setShowLoader(false);
      //                 navigate("/ViewEvents");
      //               }
      //             })
      //             .catch((err) => {
      //               setShowLoader(false);
      //               swal("There was an error!", "more error details", "warning");
      //             });
      //         } else {
      //           setShowLoader(false);
      //           swal("There was an error!", response.message, "warning");
      //         }
      //       })
      //       .catch((err) => {
      //         setShowLoader(false);
      //         swal("There was an error!", "more error details", "warning");
      //       });
      //   } else {
      //     if (membersIds.length > 0 && radiovalue === "Groups") {
      //       setshowerr(false);
      //       let inputdata;

      //       let optn = '';
      //       optn = radiovalue

      //       inputdata = {
      //         event_id: eventId,
      //         event_title: eventTitle,
      //         event_description: description,
      //         event_venue: evenue,
      //         start_date_time: eventStartDate,
      //         end_date_time: eventEndDate,
      //         sender_id: parseInt(localStorage.getItem("userId")),

      //         ...(radiovalue === "Groups" ? { group_id: selectedGroup } : {}),
      //         allow_rsvp: rsvpval,
      //         event_visible_flag: optn,
      //         member_id_list: membersIds,
      //       };

      //       await makePostRequest("events/update", inputdata)
      //         .then((response) => {
      //           if (response.status == "201") {
      //             swal("Success", "Event update Successfully", "success", {
      //               timer: 1000,
      //               buttons: false,
      //             });

      //             setShowLoader(false);
      //             navigate("/ViewEvents");
      //           }
      //         })
      //         .catch((err) => {
      //           setShowLoader(false);
      //           swal("There was an error!", "more error details", "warning");
      //         });
      //     } else {
      //       setshowerr(true);
      //     }
      //   }
      // }





    } else {
      // add ev

      // let addTime = moment().format("YYYY-MM-DD HH:mm:ss");
      let rsvpval = 1;
      if (rsvp) {
        rsvpval = 1;
      } else {
        rsvpval = 0;
      }
       inputdata = "";
      if (radiovalue === "") {
        seterrmsgradiobtn(true);
        return false;
      } else {
        seterrmsgradiobtn(false);

        const sDate = new Date(eventStartDate);
        const eDate = new Date(eventEndDate);
        let newsdate = moment(sDate).format("YYYY-MM-DD HH:mm:ss")
        let newedate = moment(eDate).format("YYYY-MM-DD HH:mm:ss")
        // console.log(newsdate)
        // return
        if (eDate > sDate) {

          if (
            radiovalue === "all" ||
            radiovalue === "committeeMembers" ||
            radiovalue === "allOwners"
          ) {
            setShowLoader(true);
            // let bodyFormData = "";

            let optn = '';
            if (radiovalue === "all") {
              optn = "All"
            } else if (radiovalue === "allOwners") {
              optn = "Owner"
            } else if (radiovalue === "committeeMembers") {
              optn = "Committee Members"
            } else if (radiovalue === "Groups") {
              optn = "Groups"
            } else {
              optn = radiovalue
            }

            // await makeGetRequest("post/getallMembersid/" + radiovalue, bodyFormData)
            //   .then((response) => {
            //     if (response.status === 201) {
            //       for (var i = 0; i < response.data.data.length; i++) {
            //         memberArr.push(response.data.data[i].resident_id);
            //       }
            setMembersIds(memberArr);
            inputdata = {
              event_title: eventTitle,
              event_description: description,
              event_venue: evenue,
              start_date_time: newsdate,
              end_date_time: newedate,
              sender_id: parseInt(localStorage.getItem("userId")),
              // created_at: addTime,
              ...(radiovalue === "Groups" ? { group_id: selectedGroup } : {}),
              allow_rsvp: rsvpval,
              event_visible_flag: optn,
              // member_id_list: memberArr,
            };

            makePostRequest("events/create", inputdata)
              .then((response) => {
                if (response.status === 201) {
                  let fcmToken = response.data.data.fcm_tokens;
                  swal("Success", "Events created successfully", "success", {
                    timer: 1000,
                    buttons: false,
                  });
                  setradioValue("");
                  setShowLoader(false);
                  // navigate("/Dashboard");

                  // send not

                  // var jsonObj = { 'val': eventTitle };
                  if (fcmToken.length > 0) {
                    let bodyFormData = {
                      title: "Events",
                      message: eventTitle,
                      firebaseToken: fcmToken,
                    };

                    makePostRequest("guards/sendNotification", bodyFormData)
                      .then((response) => {
                        swal("Success", "Events created successfully", "success", {
                          timer: 1000,
                          buttons: false,
                        });
                        navigate("/Dashboard");
                      })
                      .catch((err) => {
                        swal(
                          "There was an error in sending Notification!!",
                          "more error details",
                          "warning"
                        );
                      });

                  } else {


                    swal('Can not send notification,as FCM token not avaiable')
                    navigate("/Dashboard");
                  }
                }
              })
              .catch((err) => {
                setShowLoader(false);
                swal("There was an error!", "more error details", "warning");
              });
            // } else {
            //   setShowLoader(false);
            //   swal("There was an error!", response.message, "warning");
            // }
            // })
            // .catch((err) => {
            //   setShowLoader(false);
            //   swal("There was an error!", "more error details", "warning");
            // });
          } else {
            if (radiovalue === "Groups") {
              setshowerr(false);
              let inputdata;

              let optn = '';
              if (radiovalue === "all") {
                optn = "All"
              } else if (radiovalue === "allOwners") {
                optn = "Owners"
              } else if (radiovalue === "committeeMembers") {
                optn = "Committee Members"
              } else if (radiovalue === "Groups") {
                optn = "Groups"
              } else {
                optn = radiovalue
              }

              inputdata = {
                event_title: eventTitle,
                event_description: description,
                event_venue: evenue,
                start_date_time: newsdate,
                end_date_time: newedate,
                sender_id: parseInt(localStorage.getItem("userId")),
                // created_at: addTime,
                ...(radiovalue === "Groups" ? { group_id: selectedGroup } : {}),
                allow_rsvp: rsvpval,
                event_visible_flag: optn,
                // member_id_list: membersIds,
              };

              await makePostRequest("events/create", inputdata)
                .then((response) => {
                  if (response.status === 201) {
                    swal("Success", "Event created Successfully", "success", {
                      timer: 1000,
                      buttons: false,
                    });
                    setradioValue("");
                    setShowLoader(false);
                    // navigate("/Dashboard");


                    // send not

                    // var jsonObj = { 'val': eventTitle };
                    if (fcmarr.length > 0) {

                      let bodyFormData = {
                        title: "Events",
                        message: eventTitle,
                        firebaseToken: fcmarr,
                      };

                      makePostRequest("guards/sendNotification", bodyFormData)
                        .then((response) => {
                          swal("Success", "RSVP added", "success", {
                            timer: 1000,
                            buttons: false,
                          });
                          navigate("/Dashboard");
                        })
                        .catch((err) => {
                          swal(
                            "There was an error in sending Notification!!",
                            "more error details",
                            "warning"
                          );
                        });


                    } else {
                      swal('Can not send notification,as FCM token not avaiable')
                      navigate("/Dashboard");
                    }
                  }
                })
                .catch((err) => {
                  setShowLoader(false);
                  swal("There was an error!", "more error details", "warning");
                });
            } else {
              setshowerr(true);
            }
          }
        } else {
          swal("Invalid Time!", 'Event end time should be greater than start time', "warning");
        }
      }

    }
  }

  // const handleChangeStartDate = (date) => {
  //   if (date.format("DD MM YYYY") >= moment().format("DD MM YYYY")) {
  //     setEventStartDate(date);

  //     if (date.format("DD MM YYYY") == moment().format("DD MM YYYY")) {
  //       if (date.format("HH") >= moment().format("HH")) {
  //         setEventStartDate(date);
  //         if (date.format("HH") == moment().format("HH")) {
  //           if (date.format("mm") >= moment().format("mm")) {
  //             setEventStartDate(date);
  //           } else {
  //             swal("Invalid Time!", "Unable to select past time", "warning", {
  //               timer: 3000,
  //               buttons: false,
  //             });
  //             setEventStartDate(new Date());
  //           }
  //         }
  //       } else {
  //         swal("Invalid Time!", "Unable to select past time", "warning", {
  //           timer: 3000,
  //           buttons: false,
  //         });
  //         setEventStartDate(new Date());
  //       }
  //     }
  //   } else {
  //     swal("Invalid Date!", "Unable to select past date", "warning", {
  //       timer: 3000,
  //       buttons: false,
  //     });
  //     setEventStartDate(new Date());
  //   }
  // };

  // const handleChangeEndDate = (date) => {
  //   if (date.format("DD MM YYYY") >= eventStartDate.format("DD MM YYYY")) {
  //     setEventEndDate(date);

  //     if (date.format("DD MM YYYY") == eventStartDate.format("DD MM YYYY")) {
  //       if (date.format("HH") >= eventStartDate.format("HH")) {
  //         setEventEndDate(date);
  //         if (date.format("HH") == eventStartDate.format("HH")) {
  //           if (date.format("mm") >= eventStartDate.format("mm")) {
  //             setEventEndDate(date);
  //           } else {
  //             swal("Invalid Time!", "Unable to select past time", "warning", {
  //               timer: 3000,
  //               buttons: false,
  //             });
  //             setEventEndDate(new Date());
  //           }
  //         }
  //       } else {
  //         swal("Invalid Time!", "Unable to select past time", "warning", {
  //           timer: 3000,
  //           buttons: false,
  //         });
  //         setEventEndDate(new Date());
  //       }
  //     }
  //   } else {
  //     swal("Invalid Date!", "Unable to select past date", "warning", {
  //       timer: 3000,
  //       buttons: false,
  //     });
  //     setEventEndDate(new Date());
  //   }
  // };

  const handleChangeStartDate = (date) => {
    setEventStartDate(date);
  }
  const handleChangeEndDate = (date) => {
    setEventEndDate(date);
  }
  const handleChangeradio = (e) => {
    setflgforedit("reset")
    seterrmsgradiobtn(false);
    setshowerr(false);
    memberArr.length = 0;
    membersIds.length = 0;
    let selectedVal = e.target.value;

    let userFlag = "";
    setradioValue(selectedVal);
    if (selectedVal === "Groups") {
      setIsSelectGroup(true);
      GetAllGroups();
    } else {
      setIsSelectGroup(false);
      if (e.target.value === "Committee Members") {
        userFlag = "CommitteeMem";
      } else {
        userFlag = selectedVal;
        console.log(userFlag)
      }
    }
  };

  async function GetAllGroups() {
    await makeGetRequest("group/getAllGroups/" + localStorage.getItem("userId"))
      .then((response) => {
        if (response.status === 201) {
          setGroupsList(response.data.data.rows);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function createGroup() {
    if (group_name == "" || group_name == undefined) {
      swal("warning", "Group name should not be empty", "warning");
      return false;
    } else if (group_description == "" || group_description == undefined) {
      swal("warning", "Description should not be empty", "warning");
      return false;
    } else if (membersIds.length == 0) {
      swal("warning", "Please select at least one member", "warning");
      return false;
    } else {
      setShowLoader(true);
      let inputdata;
      inputdata = {
        group_name: group_name,
        group_description: group_description,
        resident_id: parseInt(localStorage.getItem("userId")),
      };
      await makePostRequest("group/createGroup", inputdata)
        .then((response) => {
          if (response.data.status === "1") {
            let groupData = {
              group_id: response.data.data.group_id,
              member_id: membersIds,
            };
            makePostRequest("group/addGroupMember", groupData)
              .then((response) => {
                if (response.data.status === "1") {
                  swal("Success", "Group created successfully", "success", {
                    timer: 1000,
                    buttons: false,
                  });
                  setGroupName("");
                  setGroupDesc("");
                  setOpen3(false);
                  // setOpen2(true);
                  setShowLoader(false);
                  GetAllGroups();
                }
              })
              .catch((err) => {
                setShowLoader(false);
                swal("There was an error!", "more error details", "warning");
              });
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    }
  }
  let finalarr = [];
  const handleChangeGroup = async (e) => {
    setSelectedGroup(e.target.value);
    setShowLoader(true);
    setshowerr(false);
    await makeGetRequest("group/viewGroupMember/" + e.target.value)
      .then((response) => {
        if (response.status === 201) {
          console.log(response.data.data)
          for (var i = 0; i < response.data.data.length; i++) {
            if (response.data.data[i].fcm_token !== "") {
              finalarr.push(response.data.data[i].fcm_token);
            }

          }
          var filtered = finalarr.filter(function (el) {
            return el != null;
          });
          console.log('fil', filtered);
          setfcmarr(filtered);
          setShowLoader(false);
        } else {
          setfcmarr([]);
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  };

  const handleClose3 = () => {
    setGroupName("");
    setGroupDesc("");
    setOpen3(false);
    // setOpen2(true);
  };

  const handleClickOpen3 = (scrollType) => () => {
    // setSelectedGroup();
    memberArr.length = 0;
    membersIds.length = 0;
    residentlisting();
    setOpen3(true);
    // setOpen2(false);
    setScroll3(scrollType);
    // setradioValue("");
  };

  async function getEventById(keyInfo) {
    // alert("clk")
    setShowLoader(true)
    let usearry = JSON.parse(keyInfo);
    console.log(usearry)
    setEventId(usearry.event_id);
    seteventTitle(usearry.event_title);
    setDescription(usearry.event_description);
    setevenue(usearry.event_venue);

    // setEventStartDate(usearry.start_date_time);
    // setEventEndDate(usearry.end_date_time);
    setradioValue(usearry.event_visible_flag);
    let startTimeval = moment(usearry.start_date_time).utc().format("MM-DD-YYYY hh:mm A");
    let endTimeval = moment(usearry.end_date_time).utc().format("MM-DD-YYYY hh:mm A");

    setEventStartDate(startTimeval);
    setEventEndDate(endTimeval);

    if (usearry.allow_rsvp == 0) {
      setrsvp(false);
    } else {
      setrsvp(true);
    }
    setShowLoader(false)
  }


  useEffect(() => {
    if (id > 0) {
      getEventById(localStorage.getItem("editEventData"));
    }
  }, []);


  if (id > 0) {
    var formikInitials = {
      eventTitle: eventTitle,
      description: description,
      evenue: evenue,
      // radiovalue: radiovalue
    };
  }
  else {
    var formikInitials = {
      eventTitle: "",
      description: "",
      evenue: "",
    };
  }


  const Validation_Schema = Yup.object().shape({
    eventTitle: Yup.string()
      .trim("White spaces not allow")
      .strict(true)
      .required("Required")
      .matches(/^[a-zA-Z .'"]*$/, "Please enter valid event title"),
    description: Yup.string()
      .trim("White spaces not allow")
      .strict(true)
      .required("Required"),
    evenue: Yup.string().required("Required"),
  });

  async function residentlisting() {
    setShowLoader(true);
    let bodyFormData = {
      searchq: "",
      pageNo: "",
      count: "",
      // isTenent:""
    };

    await makePostRequest("resident/residentandtenentlisting", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log(response.data.data.rows);
          const data = response.data.data.rows;
          setresidentlist(data);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handleChangeSelectedResident = (residentId) => {
    setshowerr(false);
    // membersIds.push(residentId);
    // setMembersIds(membersIds);
    setMembersIds((memIds) => {
      const index = memIds.indexOf(residentId);
      if (index !== -1) {
        //remove
        const updatedIds = [...memIds];
        updatedIds.splice(index, 1);
        return updatedIds;
      } else {
        //add
        return [...memIds, residentId];
      }
    });
    setActiveIndex(residentId);
  };

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            {(id > 0) ?
              <h1 className="panelHeading">Edit Event</h1> :
              <h1 className="panelHeading">Add Event</h1>}
            {/* <Button
              className="contentTopLefBt"
                onClick={handleClickOpen("body")}
            >
              Download
            </Button> */}
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="addEvMain">
              <div className="addEvMainInr">
                <Formik
                  enableReinitialize
                  initialValues={formikInitials}
                  validationSchema={Validation_Schema}
                  onSubmit={addEvent}
                >
                  {({
                    values,
                    handleChange,
                    errors,
                    setFieldTouched,
                    touched,
                    isValid,
                    handleSubmit,
                  }) => (
                    <Form>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Event Title <span className="asterisk">*</span></label>
                          <input
                            type="text"
                            className="inputSt"
                            value={values.eventTitle}
                            onChange={handleChange("eventTitle")}
                            onBlur={() => setFieldTouched("eventTitle")}
                            onChangeCapture={(e) =>
                              seteventTitle(e.target.value)
                            }
                          />
                          {errors.eventTitle && touched.eventTitle ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.eventTitle}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Event Venue <span className="asterisk">*</span></label>
                          <input
                            type="text"
                            className="inputSt"
                            value={values.evenue}
                            onChange={handleChange("evenue")}
                            onBlur={() => setFieldTouched("evenue")}
                            onChangeCapture={(e) => setevenue(e.target.value)}
                          />
                          {errors.evenue && touched.evenue ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.evenue}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <label className="tabsLabel">Event description <span className="asterisk">*</span></label>
                          <textarea
                            className="textAriaSt"
                            value={values.description}
                            onChange={handleChange("description")}
                            onBlur={() => setFieldTouched("description")}
                            onChangeCapture={(e) =>
                              setDescription(e.target.value)
                            }
                          />
                          {errors.description && touched.description ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.description}
                            </div>
                          ) : null}
                        </Grid>


                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Start Date-Time <span className="asterisk">*</span></label>
                          <div className="openNewDayNHrsMain">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                                disablePast
                                className="modalInputStSelect"
                                value={eventStartDate}
                                onChange={handleChangeStartDate}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              />
                            </LocalizationProvider>
                          </div>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">End Date-Time <span className="asterisk">*</span></label>
                          <div className="openNewDayNHrsMain">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                                disablePast
                                className="modalInputStSelect"
                                value={eventEndDate}
                                onChange={handleChangeEndDate}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              />
                            </LocalizationProvider>
                          </div>
                        </Grid>

                        {(id > 0) ?
                          <Grid item xs={12} md={12}>
                            <label className="tabsLabel">Visible to </label>
                            <RadioGroup
                              aria-labelledby="demo-radio-buttons-group-label"
                              value={radiovalue}
                              onChange={(e) => handleChangeradio(e)}
                              name="radio-buttons-group"
                              className="modalRadioOutNotic"
                            >
                              <FormControlLabel
                                value="All"
                                control={<Radio />}
                                label="All"
                              />
                              <FormControlLabel
                                value="Committee Members"
                                control={<Radio />}
                                label="Committee Members"
                              />
                              <FormControlLabel
                                value="Owner"
                                control={<Radio />}
                                label="All Owners"
                              />
                              <FormControlLabel
                                value="Groups"
                                control={<Radio />}
                                label="Group"
                              />
                            </RadioGroup>
                            {errmsgradiobtn ? (
                              <div
                                style={{ color: "red" }}
                                className="errorField"
                              >
                                {"Required"}
                              </div>
                            ) : null}

                          </Grid>
                          :


                          <Grid item xs={12} md={12}>
                            <label className="tabsLabel">Visible to </label>
                            <div
                              className="radioGroupNew radioGrNew"
                              onChange={(e) => handleChangeradio(e)}
                            >
                              <FormControl>
                                <RadioGroup
                                  aria-labelledby="demo-radio-buttons-group-label"
                                  defaultValue="female"
                                  name="radio-buttons-group"
                                >
                                  <FormControlLabel
                                    value="all"
                                    control={<Radio />}
                                    label="All"
                                  />
                                  <FormControlLabel
                                    value="committeeMembers"
                                    control={<Radio />}
                                    label="Committee Members"
                                  />
                                  <FormControlLabel
                                    value="allOwners"
                                    control={<Radio />}
                                    label="All Owners"
                                  />
                                  <FormControlLabel
                                    value="Groups"
                                    control={<Radio />}
                                    label="Group"
                                  />
                                </RadioGroup>
                                {errmsgradiobtn ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {"Required"}
                                  </div>
                                ) : null}
                              </FormControl>
                            </div>
                          </Grid>
                        }

                        {(id > 0) ?
                          <Grid item xs={12} md={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  onChange={(event) =>
                                    setrsvp(event.target.checked)
                                  }
                                  // value={rsvp}
                                  checked={rsvp}
                                />
                              }
                              label="Allow RSVP"
                            />
                          </Grid> :

                          <Grid item xs={12} md={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  onChange={(event) =>
                                    setrsvp(event.target.checked)
                                  }
                                  value={rsvp}
                                />
                              }
                              label="Allow RSVP"
                            />
                          </Grid>
                        }

                        {isSelectGroup ? (
                          <Grid item xs={12} md={12}>
                            <div className="refreshOut">
                              <select
                                className="modalInputStSelect"
                                value={selectedGroup}
                                onChange={handleChangeGroup}
                              >
                                <option>Select Group</option>
                                {groupsList.length > 0 ? (
                                  <>
                                    {groupsList.map((option) => (
                                      <option
                                        key={option.group_id}
                                        value={option.group_id}
                                        data-isd={option.group_name}
                                      >
                                        {option.group_name}
                                      </option>
                                    ))}
                                  </>
                                ) : (
                                  <></>
                                )}
                              </select>
                              {showerr ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {"Required"}
                                </div>
                              ) : null}
                              <div className="refreshList">
                                <ReplayCircleFilledIcon />
                              </div>
                            </div>
                            <div className="orDivider">
                              <span>OR</span>
                            </div>
                            <div className="cretaeGroupLink">
                              <a onClick={handleClickOpen3("body")}>
                                Create New Group
                              </a>
                            </div>
                          </Grid>
                        ) : (
                          <></>
                        )}

                        {(id > 0) ?
                          <Grid item xs={12} md={12}>
                            <Button className="addBt PreviewBtn" onClick={() => navigate('/ViewEvents')}>
                              Cancel
                            </Button>
                            <Button className="addBt PreviewBtn" type="submit">
                              Update Event
                            </Button>
                          </Grid> :
                          <Grid item xs={12} md={12}>
                            <Button className="addBt PreviewBtn" type="submit">
                              Add Event
                            </Button>
                          </Grid>}


                      </Grid>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      {/*Create Group Madal */}
      <div className="modalMain">
        <Dialog
          open={open3}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className="groupModal"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Create New Group</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose3} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <label className="tabsLabel">Group Name</label>
                  <input
                    className="inputSt"
                    placeholder="Type Group Name"
                    value={group_name}
                    onChange={(e) => setGroupName(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <label className="tabsLabel">Group Description</label>
                  <input
                    className="inputSt"
                    placeholder="Type Group Description"
                    value={group_description}
                    onChange={(e) => setGroupDesc(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <label className="tabsLabel">Add Members in a group</label>
                  <div className="searchOut">
                    <div className="modalInput">
                      <SearchIcon />
                      <input
                        className="modalInputSt"
                        placeholder="Search Members"
                        onChangeCapture={(e) => setressearch(e.target.value)}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={12}>
                  <div className="visitContDivScroll">

                    {residentlist.map((option) => (
                      <div
                        key={option.resident_id}
                        className={
                          membersIds.includes(option.resident_id)
                            ? "visitContDiv visitContDivNotice selectedTile draftSection"
                            : "visitContDiv visitContDivNotice draftSection"
                        }
                        onClick={() =>
                          handleChangeSelectedResident(option.resident_id)
                        }
                      >
                        <div className="visitCont1 resideNewContOut buildingNameNcountMainmini">
                          {option.apartment ? (
                            <>
                              {/* {option.apartment.} */}
                              {option.apartment.map((resApt, index) => (
                                <>
                                  {resApt.is_current_stay == true &&
                                    (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                    // {setTempCurrentStay(true)}
                                    <div className="NewTailCountOut miniBox">
                                      <div className="buildingNameNcount">
                                        <p>
                                          {
                                            resApt.uniq_apt_name.split(
                                              "/"
                                            )[0]
                                          }
                                        </p>
                                        <p>
                                          {
                                            resApt.uniq_apt_name.split(
                                              "/"
                                            )[1]
                                          }
                                        </p>
                                      </div>
                                      <h1>
                                        {
                                          resApt.uniq_apt_name.split(
                                            "/"
                                          )[2]
                                        }
                                      </h1>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ))}
                              {option.currentstaycnt.count == 0 &&
                                (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                <div className="NewTailCountOut defaultTailCount miniBox">
                                  <div className="buildingNameNcount">
                                    <p>No Apart.</p>
                                    <p>Occupied</p>
                                  </div>
                                  <h1>F-000</h1>
                                </div>
                              ) : (
                                <></>
                              )}

                              {option.user_type == "tenent" && (
                                <>
                                  {option.apartment.map(
                                    (resApt, index) => (
                                      <div className="NewTailCountOut miniBox">
                                        <div className="buildingNameNcount">
                                          <p>
                                            {
                                              resApt.uniq_apt_name.split(
                                                "/"
                                              )[0]
                                            }
                                          </p>
                                          <p>
                                            {
                                              resApt.uniq_apt_name.split(
                                                "/"
                                              )[1]
                                            }
                                          </p>
                                        </div>
                                        <h1>
                                          {
                                            resApt.uniq_apt_name.split(
                                              "/"
                                            )[2]
                                          }
                                        </h1>
                                      </div>
                                    )
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <div className="NewTailCountOut defaultTailCount miniBox">
                                <div className="buildingNameNcount">
                                  <p>No Apart.</p>
                                  <p>Occupied</p>
                                </div>
                                <h1>F-000</h1>
                              </div>
                            </>
                          )}

                          <div className="visitContProf">
                            {option.user_obj.profile_pic ? (
                              <Zoom>
                                <img src={option.user_obj.profile_pic} alt="altimg"/>
                              </Zoom>
                            ) : (
                              <img alt="Remy Sharp" src={avtarPic}/>
                            )}
                          </div>
                          <div className="visitContLeft">
                            <h3 className="visitContHed">
                              {option.user_obj.first_name}{" "}
                              {option.user_obj.last_name}{" "}
                            </h3>
                            <p className="visitContMob">
                              {option.user_obj.contact_no}
                            </p>
                          </div>
                          <div className="visitBottCont forMyTexAlign">
                            {option.apartment ? (
                              <div>
                                <>
                                  {option.apartment.map((opt) => (
                                    <>
                                      {(opt.is_current_stay == true ||
                                        opt.occupancy_type == "Vacant") &&
                                        (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                        <b className="visitContMob">
                                          {opt.uniq_apt_name}
                                          <em>{opt.occupancy_type}</em>
                                          <br />
                                        </b>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ))}
                                </>

                                {option.user_type == "tenent" && (
                                  <>
                                    {option.apartment.map(
                                      (opt1, index) => (
                                        <b className="visitContMob">
                                          {opt1.uniq_apt_name}
                                          <em>{opt1.occupancy_type}</em>
                                        </b>
                                      )
                                    )}
                                  </>
                                )}
                              </div>
                            ) : (
                              <div>No Apartment Allocated</div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}


                  </div>
                  {showerr ? (
                    <div style={{ color: "red" }} className="errorField">
                      {"Required"}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} md={12}>
                  <div className="modalMainBtMain">
                    <Button
                      className="modalMainBt"
                      onClick={() => createGroup()}
                    >
                      {" "}
                      Create Group{" "}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader && (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      )}
    </>
  );
}

export default AddEvent;
